package eu.codlab.compose.theme

import androidx.compose.ui.graphics.Color

object AppColor {
    val Violet = Color(0xFF7D33FF)
    val VioletLight = Color(0xFF8e50fa)
    val VioletLighter = Color(0xFFB083FF)
    val VioletEvenLighter = Color(0xFFba96fa)
    val Blue = Color(0xFF3E44FE)
    val BlueLight = Color(0xFF35C8FF)
    val BlueLighter = Color(0xFFA5E6FF)
    val Pink = Color(0xFFFF2E7E)
    val PinkLight = Color(0xFFFF7AAD)
    val Black = Color(0xFF13141C)
    val GrayExtraDark = Color(0xFF2E2E31)
    val GrayDark = Color(0xFF717276)
    val GraySemiTransparentLight = Color(0x66FFFFFF)
    val GraySemiTransparentDark = Color(0x66000000)
    val Gray = Color(0xFFA0A1A4)
    val GrayLight = Color(0xFFA0A1A4)
    val GrayExtraLight = Color(0xFFE7E7E8)
    val Black10 = Color(0x1913141C)
    val Black05 = Color(0x0D13141C)
    val Red = Color(0xFFD63838)

    val BackgroundBlue: Color = Color(0xff0d1a2e)
}
